import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FasSyncAlt, FasExclamationTriangle, FasCheckCircle } from 'assets/icons';
import { ATCONSTANTS as ATC } from 'appconstants';
import { getCurrentQueuedItemsSelector } from 'reducers/cirb';
import { AppContext } from '@ctsu/loader';
import _ from 'lodash';

const addschar = (v) => (v.length === 1 ? '' : 's');

function ProcessBanner() {
  const currentQueueList = useSelector(getCurrentQueuedItemsSelector);
  const context = useContext(AppContext);
  const { session } = context;

  const { pendings, completed, failed } = useMemo(() => {
    const failedEvents = currentQueueList.filter((f) => f.status.includes('FAILED'));
    return {
      pendings: currentQueueList
        .filter((f) => f.status === 'PENDING' || f.status === 'PROCESSING')
        .map((m) => m.cirbEventId),
      completed: currentQueueList.filter((f) => f.status === 'COMPLETE').map((m) => m.cirbEventId),
      // for failed events create as span to dispaly tooltip.
      failed: failedEvents.map((d, i) => (
        // we will get repeated events id, so adding it to the index to resolve warning.
        <span key={`${d.cirbEventId}-${_.uniqueId()}`} title={d.status}>
          {`${d.cirbEventId}${failedEvents.length - 1 === i ? '' : ','}`}
&nbsp;
        </span>
      ))
    };
  }, [currentQueueList]);

  if (session && currentQueueList.length > 0) {
    return (
      <div
        data-id={`${ATC.CAPID}PROCESSING${ATC.DIV}`}
        className="align-center color-blue-darker bg-blue-lighter p-1 shadow-sm"
        aria-live="polite"
      >
        {pendings.length > 0 ? (
          <div className="d-flex row justify-content-center">
            <div className="mr-2" style={{ animation: 'spin 5s linear infinite' }}>
              <FasSyncAlt />
            </div>
            Processing for event
            {addschar(pendings)}
            {' '}
            {pendings.join(', ')}
            {' '}
            {pendings.length === 1 ? 'is' : 'are'}
            {' '}
            in
            progress.
          </div>
        ) : null}
        {completed.length ? (
          <div className="d-flex row justify-content-center">
            <div className="mr-2">
              <FasCheckCircle />
            </div>
            Your request for event
            {addschar(completed)}
            {' '}
            {completed.join(', ')}
            {' '}
            {completed.length === 1 ? 'is' : 'are'}
            {' '}
            complete.
          </div>
        ) : null}
        {failed.length ? (
          <div className="d-flex row justify-content-center">
            <div className="mr-2">
              <FasExclamationTriangle />
            </div>
            Your request for event
            {addschar(failed)}
&nbsp;
            {failed}
            {' '}
            failed.
          </div>
        ) : null}
      </div>
    );
  }
  return null;
}

export default ProcessBanner;
